import { useState } from "react";
import { topicCategories, topicTags } from "@/mocks/home";

function tagClass(heat: number, active: boolean) {
  if (active) {
    return "border-primary-500 bg-primary-500 text-background-50";
  }
  if (heat >= 90) {
    return "border-accent-200 bg-accent-100 text-accent-800 text-base font-semibold";
  }
  if (heat >= 70) {
    return "border-primary-200 bg-primary-100 text-primary-800 text-sm font-medium";
  }
  if (heat >= 50) {
    return "border-secondary-200 bg-secondary-100 text-secondary-800 text-sm";
  }
  return "border-background-200 bg-background-100 text-foreground-600 text-xs";
}

export default function TopicWall() {
  const [category, setCategory] = useState("全部");
  const [activeTag, setActiveTag] = useState<string | null>(null);

  const visibleTags =
    category === "全部"
      ? topicTags
      : topicTags.filter((tag) => tag.category === category);

  return (
    <section id="topics" className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-price-tag-3-line"></i>
            </span>
            TOPIC WALL
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            话题墙 · 标签索引
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            词越大代表讨论越多，点一个标签就能缩小范围看相关内容。
          </p>
        </div>
        <span className="whitespace-nowrap text-xs text-foreground-500">
          当前 {visibleTags.length} 个话题 · 全站 1,042 个
        </span>
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-2 rounded-full border border-background-200/80 bg-background-100/70 p-1">
        {topicCategories.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => {
              setCategory(item);
              setActiveTag(null);
            }}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
              category === item
                ? "bg-foreground-950 font-medium text-background-50"
                : "text-foreground-600 hover:bg-background-50 hover:text-foreground-950"
            }`}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-2.5 rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-7">
        {visibleTags.map((tag) => {
          const active = activeTag === tag.name;
          return (
            <button
              key={tag.name}
              type="button"
              onClick={() => setActiveTag(active ? null : tag.name)}
              className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-1.5 transition-colors ${tagClass(
                tag.heat,
                active
              )}`}
            >
              {tag.name}
              <span className={active ? "text-background-50/70" : "opacity-55"}>
                {tag.heat}
              </span>
            </button>
          );
        })}
        {visibleTags.length === 0 && (
          <p className="py-4 text-sm text-foreground-500">该分类下暂无话题。</p>
        )}
      </div>
    </section>
  );
}